import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Reveal";
import { BUSINESS } from "@/lib/site";

const SECTIONS = [
  {
    title: "1. About these terms",
    body: `These terms apply to the use of the ${BUSINESS.fullName} website and to enquiries and bookings made with us. By using this website or engaging our services, you accept these terms.`,
  },
  {
    title: "2. Quotes and pricing",
    body: `Quotes are provided free of charge and without obligation. Pricing depends on the property, the type and scope of cleaning, frequency and any additional requirements. A quote is confirmed in writing before any work is scheduled. Submitting an enquiry does not create a booking.`,
  },
  {
    title: "3. Bookings and scheduling",
    body: `Cleaning times are subject to availability and are confirmed with you directly. Requests submitted through this website are enquiries, not confirmed appointments, until we confirm them with you.`,
  },
  {
    title: "4. End-of-lease cleaning",
    body: `End-of-lease (bond) cleaning is carried out to a detailed standard based on the information provided about the property. Cleaning requirements vary between properties, landlords and tenancy agreements, and the return of a rental bond depends on the property manager or landlord's assessment. We do not guarantee bond refunds.`,
  },
  {
    title: "5. Access and property information",
    body: `You agree to provide accurate information about the property and reasonable access at the agreed time. Letting us know about anything relevant — such as access instructions, parking, pets or areas of concern — helps us deliver the service you expect.`,
  },
  {
    title: "6. Website content",
    body: `We aim to keep the information on this website accurate and current, but content is general in nature and may change without notice. Nothing on this website constitutes a binding offer of service until confirmed directly with us.`,
  },
  {
    title: "7. Contact",
    body: `Questions about these terms? Contact us at ${BUSINESS.email} or call ${BUSINESS.phone}.`,
  },
];

const Terms = () => (
  <>
    <Seo
      title="Terms & Conditions | Oz SpotNest Cleaning Service"
      description="Terms and conditions for using the Oz SpotNest Cleaning Service website and engaging our cleaning services across Sydney, NSW."
    />
    <PageHero
      eyebrow="Legal"
      title="Terms &"
      highlight="Conditions"
      description="The terms that apply when you use our website or book a cleaning service with us."
    />
    <section className="section-pad" data-testid="terms-content">
      <div className="container-site max-w-3xl space-y-10">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.04}>
            <h2 className="text-xl font-semibold tracking-tight sm:text-2xl">{s.title}</h2>
            <p className="mt-3 text-sm leading-relaxed sm:text-base">{s.body}</p>
          </Reveal>
        ))}
        <Reveal>
          <p className="text-xs text-slate-400">Last updated: July 2026 · {BUSINESS.fullName}, {BUSINESS.address}</p>
        </Reveal>
      </div>
    </section>
  </>
);

export default Terms;
